import isMobile from 'ismobilejs'
import React from 'react'
import { Image, Css, Container } from '@pmi/pmi-iqos-ds-react'

const ProductSelect = ({
  products,
  id,
  onSelectProduct,
  highlightedProduct,
  selectedProducts
}) => {
  const getOption = index => products[index].options[selectedProducts[index]]
  const isSelected = index => highlightedProduct === index
  const getProductContainer = index => {
    const promotionalBadge = getOption(index).promotionalBadge || null
    return (
      <Css
        s={{
          boxSizing: 'border-box',
          width: '100%',
          height: index > 0 ? '50%' : '100%',
          transition: 'all .3s ease',
          padding: isSelected(index) ? '1rem' : '2rem'
        }}>
        <Container
          fullHeight
          bg={isSelected(index) ? Container.backgrounds.hardWhite : null}>
          <Container
            position={Container.positions.relative}
            display={Container.displays.flex}
            alignItems={Container.alignItemsValues.center}
            justifyContent={Container.justifyContentValues.center}
            fullWidth
            fullHeight
            onClickHandler={() => onSelectProduct(index)}
            data-testing="ProductBundleDetail_Overlay_SelectProduct">
            {promotionalBadge && (
              <Css
                s={
                  isMobile().any
                    ? {
                        width: promotionalBadge.mobileWidth || 'auto',
                        height: promotionalBadge.mobileHeight || 'auto',
                        position: 'absolute',
                        right: promotionalBadge.mobileRightMargin || '0',
                        top: promotionalBadge.mobileTopMargin || '0'
                      }
                    : {
                        width: promotionalBadge.desktopWidth || 'auto',
                        height: promotionalBadge.desktopHeight || 'auto',
                        position: 'absolute',
                        right: promotionalBadge.desktopRightMargin || '0',
                        top: promotionalBadge.desktopTopMargin || '0'
                      }
                }>
                <Image width="full" src={promotionalBadge.url_bdp} />
              </Css>
            )}
            {products[index] && (
              <Container zIndex="1">
                <Image
                  src={getOption(index).image.path}
                  alt={getOption(index).image.alt}
                />
              </Container>
            )}
          </Container>
        </Container>
      </Css>
    )
  }
  return (
    <Container id={id} height={['80', '128']} display={Container.displays.flex}>
      <Container width={products.length < 2 ? '1' : '3/5'}>
        {getProductContainer(0)}
      </Container>
      {products.length > 1 && (
        <Container
          fullHeight
          width="2/5"
          display={Container.displays.flex}
          flexDirection={Container.flexDirections.column}>
          {getProductContainer(1)}
          {products.length > 2 ? getProductContainer(2) : null}
        </Container>
      )}
    </Container>
  )
}

export default ProductSelect
